/* ==================================================
 *  Loading
 * ==================================================*/

(function ($) {

  'use strict';

  $.fn.addLoading = function (time) {
    var $this = this;

    $this.addClass('loading');

    return $this;
  };

  $.fn.removeLoading = function (time) {
    var $this = this;

    $this.removeClass('loading');

    return $this;
  };

  $(function() {
    $('body').removeClass('loading');
  });

}(jQuery));
